import { call, put, select } from 'redux-saga/effects';
import { getMyProducts as getMyProductsAda } from '@bitComponents/adabyron/product';
import { normalizeGetMyLinesResponse } from '@bitComponents/adabyron/product/normalizers';
import { USER_TYPE } from '../bitConstants/constants';
import { PRODUCT_OFFERING_TYPES, CLIENT_TYPES, PRODUCT_TYPES, getProductTypeByProductOfferingTypes, areThereProductOfferingTypesIntoOfferArray } from '../utils/catalog';
import { WEB_SERVICES } from './webServices';
import { CHARACTERISTICS } from '../catalogConstants';

const contextStore = state => state.context.data;

const classifyByCustomerTypes = (myProducts) => {
  let clientType = null;
  const products = [];
  if (myProducts && Array.isArray(myProducts)) {
    myProducts.forEach((product) => {
      const { productOfferingTypes, productId } = product;

      if (productOfferingTypes.some(element => PRODUCT_OFFERING_TYPES.PACK.includes(element.id))) {
        products.push({ productType: PRODUCT_TYPES.PACK, productId });
      } else if (productOfferingTypes.some(element => PRODUCT_OFFERING_TYPES.INCLUDED_R2R.includes(element.id))) {
        products.push({ productType: PRODUCT_TYPES.INCLUDED_R2R, productId });
      } else if (productOfferingTypes.some(element => PRODUCT_OFFERING_TYPES.ADDITIONAL_R2R.includes(element.id))) {
        products.push({ productType: PRODUCT_TYPES.ADDITIONAL_R2R, productId });
      } else if (productOfferingTypes.some(element => PRODUCT_OFFERING_TYPES.ADDITIONAL_MOBILE.includes(element.id))) {
        products.push({ productType: PRODUCT_TYPES.ADDITIONAL_MOBILE, productId });
      } else if (productOfferingTypes.some(element => PRODUCT_OFFERING_TYPES.MOBILE.includes(element.id))) {
        products.push({ productType: PRODUCT_TYPES.MOBILE, productId });
      } else if (productOfferingTypes.some(element => PRODUCT_OFFERING_TYPES.BAF.includes(element.id))) {
        products.push({ productType: PRODUCT_TYPES.BAF, productId });
      } else if (productOfferingTypes.some(element => PRODUCT_OFFERING_TYPES.ISR.includes(element.id))) {
        products.push({ productType: PRODUCT_TYPES.ISR, productId });
      } else if (productOfferingTypes.some(element => PRODUCT_OFFERING_TYPES.PREPAID.includes(element.id))) {
        products.push({ productType: PRODUCT_TYPES.PREPAID, productId });
      } else if (productOfferingTypes.some(element => PRODUCT_OFFERING_TYPES.GAME_PASS.includes(element.id))) {
        products.push({ productType: PRODUCT_TYPES.GAME_PASS, productId });
      } else if (productOfferingTypes.some(element => PRODUCT_OFFERING_TYPES.HEALTH.includes(element.id))) {
        products.push({ productType: PRODUCT_TYPES.HEALTH, productId });
      } else {
        products.push({ productType: PRODUCT_TYPES.OTHER, productId });
      }
    });

    if (products.some(element => element.productType === PRODUCT_TYPES.PACK)) {
      clientType = CLIENT_TYPES.PACK;
    } else if (products.some(element => element.productType === PRODUCT_TYPES.BAF) && products.some(element => element.productType === PRODUCT_TYPES.MOBILE)) {
      clientType = CLIENT_TYPES.CONVERGENT;
    } else if (products.some(element => element.productType === PRODUCT_TYPES.BAF)) {
      clientType = CLIENT_TYPES.ONLY_LANDLINE;
    } else if (products.some(element => element.productType === PRODUCT_TYPES.MOBILE || element.productType === PRODUCT_TYPES.ADDITIONAL_MOBILE)) {
      clientType = CLIENT_TYPES.ONLY_MOBILE;
    } else {
      clientType = CLIENT_TYPES.STANDALONE;
    }
  }

  return {
    clientType,
    products,
  };
};

export const retrieveAddresses = (myProducts) => {
  const addresses = [];
  if (myProducts && Array.isArray(myProducts)) {
    myProducts.forEach((product) => {
      if (product
        && product.productId
        && product.phone
        && product.phone.linesPhone
        && Array.isArray(product.phone.linesPhone)
      ) {
        product.phone.linesPhone.forEach((line) => {
          if (line && line.fullAdress && line.locationId) { // fullAdress viene asi mal escrito de TCOL, NO TOCAR
            const { fullAdress, locationId } = line;
            addresses.push({
              fullAddress: fullAdress,
              locationId,
              productId: product.productId,
              startDate: product.startDate,
              productType: getProductTypeByProductOfferingTypes(product.productOfferingTypes),
            });
          }
        });
      }
    });
  }

  return addresses;
};

export const retrieveConvergentProductPoIdNTvInfo = (myProducts) => {
  if (!myProducts) {
    return null;
  }
  let convergentMainPoId = '';
  let convergentProductId = '';
  let netflixPoId = '';
  let netflixModality = '';
  let tvProductId = '';
  const tvProducts = {};
  const tvProductsCaracs = {};

  if (myProducts && Array.isArray(myProducts)) {
    const clientFusionInfo = myProducts.find(
      item => item.productOfferingTypes.some(element => PRODUCT_OFFERING_TYPES.PACK.includes(element.id))
    );

    if (clientFusionInfo && clientFusionInfo.poId) {
      convergentMainPoId = clientFusionInfo.poId;
      convergentProductId = clientFusionInfo.productId;

      if (clientFusionInfo?.tv) {
        if (clientFusionInfo.tv?.productId) {
          tvProductId = clientFusionInfo.tv.productId;
        }

        if (clientFusionInfo?.tv?.productosContratadosDedependientes) {
          clientFusionInfo.tv.productosContratadosDedependientes.forEach(element => {
            const isNetflixAtMyProducts = getProductTypeByProductOfferingTypes(element.productOfferingTypes) === PRODUCT_TYPES.NETFLIX;
            if (isNetflixAtMyProducts) {
              netflixPoId = element.productId;
              netflixModality = element.characteristics.find(char => char.id == CHARACTERISTICS.NETFLIX).valueId;
            }

            const { poId, productId, bundleId, characteristics } = element;

            if (bundleId) {
              tvProducts[bundleId] = productId;
              tvProductsCaracs[bundleId] = characteristics;
            } else {
              if (
                characteristics
                && characteristics[0]
                && characteristics[0].id
                && characteristics[0].id === CHARACTERISTICS.NETFLIX
              ) {
                tvProductsCaracs[poId] = characteristics;
              }
            }
            tvProducts[poId] = productId;
          });
        }
      }
    }
  }

  return {
    convergentMainPoId,
    netflixPoId,
    netflixModality,
    tvProductId,
    tvProducts,
    tvProductsCaracs,
    convergentProductId,
  };
};


export function* getMyProducts(params) {
  const {
    normalizeHttpErrors,
    catalogSubSections = [],
    withoutCache = true,
    reduxUpdate,
    retryAllMobileLines,
  } = params;
  try {
    const context = yield select(contextStore);

    if (context.userType === USER_TYPE.OPEN) {
      return null;
    }

    const { successUpdate } = reduxUpdate;
    const response = yield call(
      getMyProductsAda,
      { catalogSubSections, withoutCache },
      context,
    );

    const addresses = retrieveAddresses(response);
    // Recupera solo lineas moviles con mas de 6 meses de antiguedad
    const { linesMobile: mobileLinesOver6Months } = normalizeGetMyLinesResponse(response, false, retryAllMobileLines);
    const { linesMobile, linesPhone } = normalizeGetMyLinesResponse(response, true, retryAllMobileLines);

    const { convergentMainPoId, netflixPoId, netflixModality, tvProductId, tvProducts, tvProductsCaracs, convergentProductId } = retrieveConvergentProductPoIdNTvInfo(response);

    const clientCategory = classifyByCustomerTypes(response);

    const myProductsInfoNormalized = {
      addresses,
      convergentMainPoId,
      convergentProductId,
      netflixPoId,
      netflixModality,
      tvProductId,
      linesMobile,
      linesPhone,
      mobileLinesOver6Months,
      clientCategory,
      rawData: response,
      tvProducts,
      tvProductsCaracs,
    };

    if (successUpdate) {
      yield put(successUpdate(myProductsInfoNormalized));
    }
    return myProductsInfoNormalized;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.GET_MY_PRODUCTS, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
